import { appFetch, AppFetchResponse } from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getLastDaysMessages = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `messages/last-days?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}